import React, { useCallback } from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Trans, useTranslation } from 'react-i18next';

import { Theme } from '@app/theme';
import { ParticipantField } from '@app/api';
import { Chip, TooltipText } from 'components';

const useStyles = createUseStyles((theme: Theme) => ({
  icon: {
    marginRight: theme.marginBase,
    fontSize: theme.iconSize.regular,
  },
  chip: {
    marginRight: theme.marginBase,
    marginBottom: theme.marginBase,
  },
  button: {},
  buttonDisabled: { opacity: 0.5 },
}));

interface Props {
  allowed?: boolean;
  addCriteria: (field: ParticipantField) => any;
  field: ParticipantField;
  disabled?: boolean;
  onForbiddenClick?: (field: ParticipantField) => any;
}

export const CriterionChip = ({
  allowed,
  addCriteria,
  field,
  disabled,
  onForbiddenClick,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  const label = (field.range && field.range.label) || field.label;

  const buttonChip = (
    <div>
      <Chip color="blue" overGray className={classes.chip} variant="round">
        <i
          className={classnames(
            classes.icon,
            allowed ? 'ri-add-line' : 'ri-lock-2-line',
          )}
        />
        {label}
      </Chip>
    </div>
  );

  const onClick = useCallback(() => {
    if (!allowed) {
      if (onForbiddenClick) {
        onForbiddenClick(field);
      }
      return;
    }
    return addCriteria(field);
  }, [addCriteria, allowed, onForbiddenClick, field]);

  return (
    <button
      disabled={disabled}
      className={classnames(classes.button, {
        [classes.buttonDisabled]: !allowed || disabled,
      })}
      onClick={onClick}
      type="button"
    >
      {disabled ? (
        <TooltipText title={t('participants.unavailableCriterion')}>
          {buttonChip}
        </TooltipText>
      ) : (
        buttonChip
      )}
    </button>
  );
};
